import { QRCodeSVG } from 'qrcode.react';

interface QrCodeProps {
  value: string;
  label: string;
  size?: number;
}

/**
 * Locally rendered QR code (the value may carry a secret, so never use a remote QR service).
 * Always black on a white plate, even in dark mode: many phone scanners can't read inverted codes.
 */
export function QrCode({ value, label, size = 176 }: QrCodeProps) {
  return (
    <div role="img" aria-label={label} className="rounded-lg bg-white p-2 shadow-sm">
      <QRCodeSVG
        value={value}
        size={size}
        level="M"
        marginSize={2}
        bgColor="#ffffff"
        fgColor="#000000"
        aria-hidden="true"
        style={{ display: 'block', maxWidth: '100%', height: 'auto' }}
      />
    </div>
  );
}
